/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ListCheckSvg = () => (
  <svg width="1.1em" height="1.1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5.66663H11.5V6.99996H1V5.66663ZM1 8.33329H11.5V9.66663L1 9.66662V8.33329ZM1 11H8.83333V12.3333H1V11ZM14.366 9.19462L11.4993 12.0553L10.638 11.1946L9.69533 12.138L11.4993 13.9406L15.3073 10.1386L14.366 9.19462Z" fill="currentColor"/>
    <path d="M11.5 3H1V4.33333H11.5V3Z" fill="currentColor"/>
  </svg>

);

export const ListCheckIcon = (props) => <Icon component={ListCheckSvg} {...props} />;
